import anaConsts from 'analytics/constants';
import analyticsUtils from 'analytics/utils';
import processEvent from 'analytics/processEvent';
import linkTrackingError from 'analytics/bindings/pages/all/linkTrackingError';
import { sendSOTLinkTrackingClickEvent } from 'analytics/utils/sotTracking';
import ErrorsActions from 'actions/ErrorsActions';
import ErrorConstants from 'utils/ErrorConstants';
import store from 'store/Store';
import orderUtils from 'utils/Order';

const { hasHalAddress } = orderUtils;

export default (function () {
    const ERROR_LEVEL = ErrorConstants.ERROR_LEVEL;

    const methods = {
        setRopisData: function () {
            digitalData.page.pageInfo.pageName = anaConsts.PAGE_NAMES.ROPIS_CHECKOUT;
        },

        setPageName: function (focus, checkoutPath) {
            // Always use the URL-based pageName for initial PAGE_LOAD.
            // Section-specific tracking (e.g., 'shipping-add address') is handled
            // by ASYNC_PAGE_LOAD calls from section components like ShipAddressSection.
            digitalData.page.pageInfo.pageName = analyticsUtils.convertName(checkoutPath);
        },

        setPageType: () => {
            digitalData.page.category.pageType = anaConsts.PAGE_TYPES.CHECKOUT;
        },

        processAsyncPageLoad: function (checkoutPath, pageTypeString = anaConsts.PAGE_TYPES.CHECKOUT) {
            const pageDetail = analyticsUtils.convertName(checkoutPath);
            const name = `${pageTypeString}:${pageDetail}:n/a:*`;

            const eventStrings = [anaConsts.Event.SC_CHECKOUT];

            if (hasHalAddress()) {
                eventStrings.push(anaConsts.Event.EVENT_247);
            }

            processEvent.process(anaConsts.ASYNC_PAGE_LOAD, {
                data: {
                    pageName: name,
                    previousPageName: digitalData.page.attributes.sephoraPageInfo.pageName,
                    eventStrings,
                    pageType: pageTypeString,
                    pageDetail
                }
            });

            // Update page name for subsequent calls
            digitalData.page.attributes.sephoraPageInfo.pageName = name;
            digitalData.page.pageInfo.pageName = pageDetail;
            analyticsUtils.setNextPageData({ pageName: name });
        },

        watchForErrors: () => {
            //Parse through the error object to get what we need in the format we need it in
            const getAnalyticsFields = (errors = {}) => {
                const formErrors = {
                    errorFields: [],
                    errorMessages: []
                };
                Object.keys(ERROR_LEVEL).forEach(errorLevel => {
                    Object.keys(errors[errorLevel]).forEach(errorKey => {
                        formErrors.errorFields.push(errorKey);
                        formErrors.errorMessages.push(errors[errorLevel][errorKey].message);
                    });
                });

                return formErrors;
            };

            const handleErrors = errors => {
                const analyticsFields = getAnalyticsFields(errors.errors);

                // Correctly set pageDetail based on most recent asyncPageLoad. If there are no
                // asyncPageLoad events, it will default to pageDetail of initial pageLoad event
                const mostRecentAsyncLoadEvent = analyticsUtils.getMostRecentEvent('asyncPageLoad');
                let pageDetail = '';
                let previousPageName = digitalData.page.attributes.previousPageData.pageName;

                if (mostRecentAsyncLoadEvent) {
                    pageDetail = mostRecentAsyncLoadEvent.eventInfo.attributes.pageDetail;
                    previousPageName = mostRecentAsyncLoadEvent.eventInfo.attributes.previousPageName;
                }

                // Promo errors are handled elsewhere and have different requirements than
                // general checkout errors
                const isPromoError = analyticsFields.errorFields.length && analyticsFields.errorFields[0] === 'basketLevelMsg';

                if ((analyticsFields.errorMessages.length || analyticsFields.errorFields.length) && !isPromoError) {
                    processEvent.process(anaConsts.LINK_TRACKING_EVENT, {
                        data: {
                            bindingMethods: linkTrackingError,
                            errorMessages: analyticsFields.errorMessages,
                            fieldErrors: analyticsFields.errorFields,
                            eventStrings: [anaConsts.Event.EVENT_71],
                            linkName: anaConsts.EVENT_NAMES.ERROR,
                            previousPage: previousPageName,
                            usePreviousPageName: true,
                            pageDetail: pageDetail,
                            pageName: digitalData.page.attributes.sephoraPageInfo.pageName
                        }
                    });
                }
            };

            store.watchAction(ErrorsActions.TYPES.VALIDATE_ERRORS, handleErrors);
        },

        triggerSOTAnalytics: ({
            eventName, sotType, pageName, origin, paymentMethod, ...data
        }) => {
            sendSOTLinkTrackingClickEvent({
                eventData: {
                    linkName: eventName,
                    actionInfo: eventName,
                    specificEventName: eventName,
                    sotType,
                    pageName,
                    origin,
                    paymentMethod,
                    ...data
                }
            });
        },

        sotPaymentOptionCheckout: paymentMethod => {
            methods.triggerSOTAnalytics({
                eventName: anaConsts.EVENT_NAMES.EXPRESS_PAYMENT_SELECTION,
                sotType: anaConsts.EVENT_NAMES.EXPRESS_PAYMENT_SELECTION,
                pageName: anaConsts.CONTEXT.CHECKOUT_PAGE,
                origin: anaConsts.EVENT_NAMES.PAYPAL_EXPRESS.PAGE_DETAIL.EXPRESS_CHECKOUT,
                paymentMethod
            });
        }
    };

    return methods;
}());
